import classnames from "classnames";
import classes from "./ContentSection.module.scss";
import { nanoid } from "nanoid";
import CascadingList from "../../core/CascadingList/CascadingList";
import Accordion from "../../core/Accordion/Accordion";
import React, { useEffect, useRef, useState, useMemo } from "react";
import CustomImage from "../../core/CustomImage/CustomImage";

const ContentSection = ({
  heading,
  subHeading,
  data,
  faqData,
  isIndexingRequired = true,
}) => {
  const cascadingListRef = useRef(null);
  const contentRef = useRef(null);
  const [activeSection, setActiveSection] = useState("");

  const callbackFnc = para => {
    setActiveSection(para);
  };

  useEffect(() => {
    const handleScroll = () => {
      const cascadingList = cascadingListRef.current;
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      if (window.innerWidth > 768 && scrollTop > 250) {
        cascadingList.classList.add(classes.sticky);
        contentRef.current.style.paddingRight = "210px";
      } else {
        cascadingList.classList.remove(classes.sticky);
        contentRef.current.style.paddingRight = "20px";
      }

      const faqDiv = document.getElementById("faqData");
      if (faqDiv) {
        const rect = faqDiv.getBoundingClientRect();
        if (rect.top <= 200) setActiveSection("faqData");
      }
    };

    const handleResize = () => {
      handleScroll();
    };

    if (isIndexingRequired) {
      window.addEventListener("scroll", handleScroll);
      window.addEventListener("resize", handleResize);
    }
    return () => {
      if (isIndexingRequired) {
        window.removeEventListener("scroll", handleScroll);
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);

  return (
    <div className={classes.contentSection}>
      <div className={classnames(classes.faqSection)} ref={contentRef}>
        <div className={classnames(classes.pageheading)}>{heading}</div>
        <div className={classnames(classes.pagesubheading)}>{subHeading}</div>
        <RenderList data={data} callbackFnc={callbackFnc} />
        {faqData && (
          <>
            <div className={classnames(classes.pageheading)} id="faqData">
              FAQ
            </div>
            <div className={classnames(classes.faqContainer)}>
              {faqData.map(o => {
                return (
                  <Accordion key={nanoid()} title={o.ques} content={o.ans} />
                );
              })}
            </div>
          </>
        )}
      </div>
      {isIndexingRequired && (
        <div ref={cascadingListRef}>
          <CascadingList
            data={data}
            title="CONTENTS"
            hasFaq={faqData}
            activeSection={activeSection}
          />
        </div>
      )}
    </div>
  );
};

const RenderList = ({ data, callbackFnc }) => {
  useEffect(() => {
    const handleScroll = () => {
      const headings = Array.from(
        document.getElementsByClassName(classes.innerheading)
      );
      let activeSectionId = null;
      for (let i = 0; i < headings.length; i++) {
        const headingRect = headings[i].getBoundingClientRect();
        if (headingRect.top <= 200) {
          activeSectionId = headings[i].id;
        }
      }
      callbackFnc(activeSectionId);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const render = list => {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "2rem",
            marginTop: "2rem",
            marginBottom: "2rem",
          }}
        >
          {list.map(l => {
            return (
              <div
                key={nanoid()}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 16,
                }}
              >
                <div>
                  <div className={classnames(classes.innerheading)} id={l.id}>
                    {l.title}
                  </div>
                  {l.image && (
                    <CustomImage src={l.image} alt="" width="100%" style={{margin:'8px 0'}} />
                  )}
                  <div
                    className={classnames(classes.innersubheading)}
                    dangerouslySetInnerHTML={{ __html: l.description }}
                  ></div>
                </div>
                {l.children && (
                  <div className={classnames(classes.children)}>
                    {l.children.map((lc, index) => {
                      return (
                        <React.Fragment key={index}>
                          <div
                            className={classnames(classes.innerheadingChildren)}
                            id={l.id}
                          >
                            {lc.title}
                          </div>
                          {lc.image && (
                            <CustomImage src={lc.image} alt="" width="100%" />
                          )}
                          <div
                            className={classnames(classes.innersubheading)}
                            dangerouslySetInnerHTML={{ __html: lc.description }}
                          ></div>
                        </React.Fragment>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </>
    );
  };
  return <div>{render(data)}</div>;
};

export default ContentSection;
